module.exports = __webpack_public_path__ + "assets/icon-orderType-fencer.756d9548.svg";